import { logout as signout, loadUser as auth } from '../services/api/auth';
import actionTypes from './action_types';

export function logout() {
  return dispatch => (signout().then(() => (dispatch({
    type: actionTypes.LOGOUT,
    payload: {},
  }))));
}

export function loadUser() {
  return dispatch => (auth().then(user => (dispatch({
    type: actionTypes.USER_LOADED,
    payload: { user },
  }))));
}



// WEBPACK FOOTER //
// ./src/actions/auth.js